import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ChartType, ChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {ErrorHandlerService} from "../shared/services/error-handler.service";
import {ActivatedRoute, Router} from '@angular/router';
import { $ } from 'protractor';
import { AuthService } from '../shared/services/auth.service';
import { CourseService } from '../shared/services/course.service';
import { AdminService } from '../shared/services/admin.service';
import {GlobalService} from '../shared/services/global.service'
import { demo_variables } from '../models/demo_global';
import { animate, style, transition, trigger } from '@angular/animations';
// import { Subscription } from 'rxjs';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({opacity:0}),
        animate(500, style({opacity:1})) 
      ]),
      transition(':leave', [
        animate(500, style({opacity:0})) 
      ])
    ])
  ]
})
export class DashboardComponent implements OnInit, OnDestroy {
  allCourses=['step 1', 'step 2 ck', 'step 3'];
  allGenders = ['Male','Female','Any'];
  Graduations = ['Undergraduate','Postgraduate'];
  allStudyLevel = ['Beginner (beginning first read)','Intermediate (Middle of first read)','Advanced (Revision phase)']
  country_list = ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antigua Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia Herzegovina","Botswana","Brazil","British Virgin Islands","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Cape Verde","Cayman Islands","Chad","Chile","China","Colombia","Congo","Cook Islands","Costa Rica","Cote D Ivoire","Croatia","Cruise Ship","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Estonia","Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Polynesia","French West Indies","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guam","Guatemala","Guernsey","Guinea","Guinea Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kuwait","Kyrgyz Republic","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Mauritania","Mauritius","Mexico","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Namibia","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Norway","Oman","Pakistan","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russia","Rwanda","Saint Pierre Miquelon","Samoa","San Marino","Satellite","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","South Africa","South Korea","Spain","Sri Lanka","St Kitts Nevis","St Lucia","St Vincent","St. Lucia","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor L Este","Togo","Tonga","Trinidad Tobago","Tunisia","Turkey","Turkmenistan","Turks Caicos","Uganda","Ukraine","United Arab Emirates","United Kingdom","Uruguay","Uzbekistan","Venezuela","Vietnam","Virgin Islands (US)","Yemen","Zambia","Zimbabwe"];

  menuItems = [
    {
      title: 'Welcome',
      icon: 'fa fa-tachometer-alt',
      status: false,
      link: '/dashboard/welcome',
      children: [],
      demo: false,
      opened: false
    },
    {
      title: 'Courses',
      icon: 'fa fa-sticky-note',
      status: false,
      link: '',
      demo: false,
      opened: false,
      children: [
        {
          title: 'My Courses',
          icon: 'fa fa-book',
          status: false,
          link: '/dashboard/courses',
          demo: false
        },
        {
          title: 'Schedule',
          icon: 'fa fa-calendar',
          status: false,
          link: '/dashboard/courses-schedule',
          demo: false
        },
      ]
    },
    {
      title: 'Qbanks',
      icon: 'fa fa-university',
      status: false,
      link: '',
      demo: false,
      opened: false,
      children: [
        {
          title: 'Previous Test',
          icon: 'fa fa-step-backward',
          status: false,
          link: '/dashboard/previoustest',
          children: [],
          demo: false,
          opened: false
        },
        {
          title: 'Generate Quiz',
          icon: 'fa fa-question',
          status: false,
          link: '/dashboard/generatequiz',
          children: [],
          demo: false,
          opened: false
        },
        {
          title: 'Search',
          icon: 'pi pi-search',
          status: false,
          link: '/dashboard/search',
          children: [],
          demo: false,
          opened: false
        }
      ]
    },
    {
      title: 'Self Assessments',
      icon: 'fa fa-graduation-cap',
      status: false,
      link: '',
      demo: false,
      opened: false,
      children: [
        {
          title: 'Assessments',
          icon: 'fa fa-tasks',
          status: false,
          link: '/dashboard/assessment-tasks',
          demo: false
        },
        {
          title: 'Report',
          icon: 'fa fa-area-chart',
          status: false,
          link: '/dashboard/assessment-report',
          demo: false
        },
        // {
        //   title: 'Score Predictor',
        //   icon: 'fa fa-calculator',
        //   status: false,
        //   link: '/dashboard/score-predictor',
        //   demo: false
        // },
      ]
    },
    
    {
      title: 'Performance',
      icon: 'fa fa-line-chart',
      status: false,
      link: '',
      demo: false,
      opened: false,
      children: [
        {
          title: 'Overall',
          icon: 'fa fa-pie-chart',
          status: false,
          link: '/dashboard/overallperformance',
          demo: false
        },
        {
          title: 'Peer Ranking',
          icon: 'fa fa-users',
          status: false,
          link: '/dashboard/peerranking',
          demo: false
        },
        {
          title: 'AI Test Analysis',
          icon: 'fa fa-users',
          status: false,
          link: '/dashboard/ai-test-analysis',
          demo: false
        },
        {
          title: 'Score Calculator',
          icon: 'fa fa-calculator',
          status: false,
          link: '/dashboard/scorecalculator',
          children: [],
          demo: false,
          opened: false
        },
        {
          title: 'Graphs',
          icon: 'fa fa-bar-chart',
          status: false,
          link: '/dashboard/overallperformancechart',
          children: [],
          demo: false,
          opened: false
        }
      ]
    },
    {
      title: 'Notes and Study',
      icon: 'fa fa-notes-medical',
      status: false,
      link: '',
      demo: false,
      opened: false,
      children: [
        {
          title: 'Notes',
          icon: 'pi pi-file',
          status: false,
          link: '/dashboard/notes',
          children: [],
          demo: false,
          opened: false
        },
        {
          title: 'My Notebook',
          icon: 'pi pi-book',
          status: false,
          link: '/dashboard/notebook',
          children: [],
          demo: false,
          opened: false
        },
        {
          title: 'Medical Library',
          icon: 'pi pi-book',
          status: false,
          link: '/dashboard/medicalLibrary',
          children: [],
          demo: false,
          opened: false
        },
        {
          title: 'Study Planner',
          icon: 'fa fa-calendar',
          status: false,
          link: '/dashboard/study-planner',
          children: [],
          demo: false,
          opened: false
        }
      ]
    },
    {
      title: 'Flashcards',
      icon: 'fa fa-bolt',
      status: false,
      link: '/dashboard/flashcard',
      demo: false,
      opened: false,
      children: [
        {
          title: 'My Decks',
          icon: 'fa fa-folder',
          status: false,
          link: '/dashboard/flashcard',
          demo: false
        },
        {
          title: 'Ready Decks',
          icon: 'fa fa-folder',
          status: false,
          link: '/dashboard/ready-flashcards',
          demo: false
        },
        {
          title: 'AI Decks',
          icon: 'fa fa-folder',
          status: false,
          link: '/dashboard/ai-flashcards',
          demo: false
        }
      ]
    },
    {
      title: 'Account',
      icon: 'fa fa-user',
      status: false,
      link: '',
      demo: false,
      opened: false,
      children: [
        {
          title: 'Renewal',
          icon: 'pi pi-credit-card',
          status: false,
          link: '/dashboard/profile/0',
          children: [],
          demo: false,
          opened: false
        },
        {
          title: 'Reset',
          icon: 'pi pi-undo',
          status: false,
          link: '/dashboard/reset',
          children: [],
          demo: false,
          opened: false
        }
      ]
    },
    {
      title: 'Ask Your Instructor',
      icon: 'pi pi-comment',
      status: false,
      link: '/dashboard/chat',
      children: [],
      demo: false,
      opened: false
    },
    {
      title: 'Referral Program',
      icon: 'pi pi-id-card',
      status: false,
      link: '/dashboard/referral-program',
      children: [],
      demo: false,
      opened: false
    }
  ]

  isProfile = false;
  // @ts-ignore
  subscriptions: Subscription = [];
  userId: any;
  isopen = false;
  userName: any;
  studyPartnerRequest: any;
  welcome = false;
    courses = false;
    previous_test = false;
    generate_quiz = false;
    Overall_Performance = false;
    Graphs = false;
    Notes = false;
    Account = false;
    calculator=false;
    search = false;
    flashcard = false;
    reset = false;
    AllStudyPartnerRequests: any;
    displayRequestModal = false;
    requestBody = {
      country: "No Country",
      course: "No Course",
      gender: "male",
      postgraduate: "none",
      studylevel: "none",
      examdate: "none",
      contact: "1234567890"
    };

    course: any;
    gender: any;
    country: any;
    postgraduate: any;
    studyLevel: any;
    examDate: any;
    contact: any;

    AdminRequest: any;

    displayAdminRequestModal = false;

    isRequestPresent = false;

    isMobView = true;

    isdemo = false;
    ischat = false
    notebook = false;

    membershipDate = new Date().toDateString();
    memberships: any = [];

    displayDemo = false

    showPerformance = false;
    noSubscription = false;
    noQbankSubscription = false;

  constructor(private globalSevice: GlobalService,private adminService: AdminService, private courseService: CourseService ,private authService: AuthService ,private route:ActivatedRoute,private router:Router, private errorHandler: ErrorHandlerService) {
    if(!localStorage.getItem("token")){
      this.logout();
    }
    // document.addEventListener('contextmenu', event => event.preventDefault());
    // document.onkeydown = function(e) {
    //   // @ts-ignore
    //   if(event.keyCode == 123) {
    //   return false;
    //   }
    //   if(e.ctrlKey && e.keyCode == 'E'.charCodeAt(0)){
    //   return false;
    //   }
    //   if(e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)){
    //   return false;
    //   }
    //   if(e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)){
    //   return false;
    //   }
    //   if(e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)){
    //   return false;
    //   }
    //   if(e.ctrlKey && e.keyCode == 'S'.charCodeAt(0)){
    //   return false;
    //   }
    //   if(e.ctrlKey && e.keyCode == 'H'.charCodeAt(0)){
    //   return false;
    //   }
    //   if(e.ctrlKey && e.keyCode == 'A'.charCodeAt(0)){
    //   return false;
    //   }
    //   if(e.ctrlKey && e.keyCode == 'F'.charCodeAt(0)){
    //   return false;
    //   }
    //   if(e.ctrlKey && e.keyCode == 'E'.charCodeAt(0)){
    //   return false;
    //   }
    //   }
  }

  allAdminNotifications: any;
  isAdminNotification = false;
  innerWidth: any;
  @HostListener('window:resize', ['$event'])
onResize(event) {
  this.innerWidth = window.innerWidth;
  if(this.innerWidth < 750){
    document.getElementById('eup_username').innerText = '';
    document.getElementById('eup-navbar-heading').innerText=''
    this.isMobView = true;
  }else{
    this.isMobView = false;
  }
}
  ngOnInit(): void {

    // see if the step 3 curse is included 
    // then add the ccs module to the menu

    // fetcching th subscriptions from the localstorage
  //   var course = localStorage.getItem("subscriptions")
   
  //   if (course){
  //      const parsedCourse: any[] = JSON.parse(course)
  //      for (let item of parsedCourse){
  //       if (item.courseID === 135631){
  //         //add this css module route to menu item at 5th indexe
  //         this.menuItems.splice(5, 0, 
  //           {
  //             title: 'CCS Module',
  //             icon: 'fa fa-desktop',
  //             status: false,
  //             link: '/ccs-module',
  //             children: [],
  //             demo: false,
  //             opened: false
  //           }
  //           )
  //           break;
  //      }
  //   }
  // }

    this.getUserSubscription()
    this.userId =JSON.parse(localStorage.getItem("Id"))

    this.innerWidth = window.innerWidth;
    if(this.innerWidth>750){
    document.getElementById('eup-navbar-heading').innerText = 'Dashboard';
    this.isMobView = false;
  }else{
    // document.getElementById('eup-navbar-heading-wrapper').innerText = '';
    document.getElementById('eup-navbar-heading').style.display = 'none';
    this.isMobView = true;
  }

  if(this.innerWidth> 500){
    this.isopen = true;
  }else{
    this.isopen = false;
  }

    if(localStorage.getItem("UserName")){
      this.userName = localStorage.getItem("UserName");
    }
    else{
    this.getUserDetails();
    }
    if(localStorage.getItem('Id')=='-1'){
      this.AllStudyPartnerRequests= [demo_variables.getStudyPartnerRequest];
      this.isdemo = true;
      this.menuItems[3].demo = true;
      this.menuItems[4].demo = true;
      this.menuItems[5].children[2].demo = true;
      this.menuItems[6].children[1].demo = true;
      this.menuItems[6].children[2].demo = true;
      this.menuItems[6].children[3].demo = true;
      this.menuItems[6].children[4].demo = true;
      this.menuItems[7].demo = true;
      this.menuItems[8].demo = true;
      this.menuItems[9].demo = true;
    }
    else{
    this.fetchStudyPartnerRequest()
    }
    this.getAdminNotifications()

    setTimeout(function () {   window.scrollTo(0, 1); }, 1000);

    // @ts-ignore
    // this.subscriptions.push(
    //   this.adminService.compareToken(JSON.parse(localStorage.getItem("Id"))).subscribe((res: any) => {
    //     if(res.status){
    //     }else{
    //       this.errorHandler.AutoLogout();
    //     }
    //   },
    //     error => {
    //       this.errorHandler.handleError(error);
    //     })
    // );
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach(item => item.unsubscribe());
  }

  openDropdown(e){
    e.stopPropagation();
  }

  deleteRequest(reqId: any, userId: any){
    var data = {
      userId: userId,
      reqId: reqId
    }
    this.courseService.deleteStudyPartnerRequest(data).subscribe((res: any) => {
      this.fetchStudyPartnerRequest()
    });
  }

  logout(): void {
    this.errorHandler.AutoLogout();
  }

  RaisePartnerRequest(): any{
    document.getElementById("fill_text").innerHTML = " "
      var data = {
        userId: JSON.parse(localStorage.getItem("Id")),
        userName: localStorage.getItem("UserName"),
        request: {
          course: this.course,
          gender: this.gender,
          country: this.country,
          postgraduate: this.postgraduate,
          studylevel: this.studyLevel,
          examdate: this.examDate,
          contact: this.contact.replace(/[\\]/g, '').replace(/[\t]/g, '').replace(/[\n]/g, '').replace(/[\r]/g, '').replace(/[']/g, '').replace(/["]/g, '')
        }
      }
      if(this.course && this.gender && this.country && this.postgraduate && this.studyLevel && this.examDate && this.contact){
      if(this.course.length > 0 && this.gender.length > 0 && this.country.length > 0 && this.postgraduate.length > 0 && this.studyLevel.length > 0 && this.examDate.length > 0 && this.contact.length > 0 ){
      this.courseService.studyPartnerRequest(data).subscribe((res: any) => {
          this.course = ''
          this.gender = ''
          this.country = ''
          this.postgraduate = ''
          this.studyLevel = ''
          this.examDate = ''
          this.contact = ''

        this.fetchStudyPartnerRequest();
        this.checkStudypartnerRequest();

      });
    }else{
      document.getElementById("fill_text").innerHTML = "Kindly Fill all the fields"
    }
  }else{
    document.getElementById("fill_text").innerHTML = "Kindly Fill all the fields"
  }

  }

  getAdminNotifications(): any{
    this.adminService.getAdminNotifications().subscribe((res: any) => {
      if(res.status){
      this.allAdminNotifications = res.res;
    }else{
      this.allAdminNotifications = [];
    }
  })
}

  fetchStudyPartnerRequest(): any{
    // @ts-ignore
    this.subscriptions.push(
    this.courseService.getStudyPartnerRequest().subscribe((res: any) => {
      if(res.status){
      this.AllStudyPartnerRequests = res?.res;
    }else{
      this.AllStudyPartnerRequests = []
    }
    },
        error => {
          this.errorHandler.handleError(error);
        })
    );

  }

  displayRequest(request: any): any{
    this.requestBody = request.request;
    this.displayRequestModal = true;
  }

  getUserDetails(): any{
    this.authService.getuserdetails().subscribe((res: any) => {
      if(res.status){
        localStorage.setItem("UserName", res.user.displayName)
        this.userName = res.user.displayName;
        this.globalSevice.tawkIO(this.userName, localStorage.getItem('email'))
    }
    else{

    }
    });
  }


  hamburgerclicked():void {
    this.isopen = !this.isopen;
    }


    displayAdminNotification(request: any){
      this.AdminRequest = request;
      this.displayAdminRequestModal = true
    }

    deleteAdminRequest(request: any){
      let notification = {
        userId: this.userId,
        notificationId: request.req_id
      }
      this.adminService.deleteAdminNotification(notification).subscribe((res: any) => {
        this.getAdminNotifications()
    })
    }


    checkStudypartnerRequest() {
      // @ts-ignore
    this.subscriptions.push(
      this.courseService.checkStudyPartner().subscribe((res: any) => {
        if(res.isDataPresent === true){
          this.isRequestPresent = true;
        }else{
          this.isRequestPresent = false
        }
      },
        error => {
          this.errorHandler.handleError(error);
        })
    );
    }

    getPremiumMembership(){
      localStorage.removeItem('token');
      window.location.href = 'https://elhusseinyusmleprep.com/register-to-courses/'
    }
    gotoProfile(isProfile: boolean){
      this.isProfile = isProfile;
      this.welcome = false ;
      this.courses = false;
      this.previous_test = false;
      this.generate_quiz = false;
      this.Overall_Performance= false;
      this.Graphs = false;
      this.Notes = false;
      this.Account = true;
      this.router.navigate(['dashboard/profile', (isProfile)?1:0 ]);
      // localStorage.setItem("isProfile",JSON.stringify(isProfile));
    }


    getUserSubscription(){
      this.noSubscription = false;
      this.noQbankSubscription = false;
      this.authService.getUserSubscription().subscribe((res: any) => {
        this.memberships = res.subscriptions.filter(item => item.Status == 'active' || item.Status == 'expired')
        this.membershipDate = res.subscriptions.filter(item => item.Status == 'active' || item.Status == 'expired').map(item => item.EndDate)
        this.membershipDate = new Date(this.membershipDate).toDateString().substring(3, 15) + ' ' + new Date(this.membershipDate).toTimeString().substring(0, 5)

        if (this.memberships.filter(item => item.Status == 'active').length <= 0) {
          this.menuItems[6].children[2].demo = true;
          this.menuItems[6].children[3].demo = true;
          this.menuItems[6].children[4].demo = true;
          this.menuItems[7].demo = true;
          this.menuItems[9].demo = true;
          this.noSubscription = true;
        } else {
          const premiumMemberships = this.memberships.filter((item: any) => (item.MembershipID !== 13 && item.MembershipID !== 14 && item.MembershipID !== 15));
          if (this.memberships.find((membership: any) => (membership.MembershipID === 18 || membership.MembershipID === 19 || membership.MembershipID === 20 || membership.MembershipID === 21 || membership.MembershipID === 22 || membership.MembershipID === 23 || membership.MembershipID === 24 || membership.MembershipID === 25) && (membership.Status === 'active'))) {
            this.menuItems[9].demo = true;
            this.noQbankSubscription = true;
          }
          if (this.memberships.find((membership: any) => (membership.MembershipID === 13 || membership.MembershipID === 14 || membership.MembershipID === 15) && (membership.Status === 'active'))) {
            if (premiumMemberships.length <= 0) {
              this.menuItems[6].children[2].demo = true;
              this.menuItems[6].children[3].demo = true;
              this.menuItems[6].children[4].demo = true;
              this.menuItems[7].demo = true;
              this.menuItems[9].demo = true;
              this.noSubscription = true;
            }
          }
        }
      })
    }


    displayDemoModal() {
      if (this.menuItems.filter((item: any) => item.demo === true).length > 0) {
        this.displayDemo = true
      }
    }

  openChildMenu(index: any) {
    if (!this.menuItems[index].demo === true) {
      this.menuItems[index].opened = !this.menuItems[index].opened;
    } else {
      this.displayDemo = true;
    }
  }

  navigateToPage(item: any) {
    this.menuItems.forEach((element: any) => {
      element.status = false;
    })
    item.status = true;
    if (item.link) {
      this.router.navigateByUrl(item.link)
    }
  }
}
